import { Component } from '@angular/core';
import { Select } from '@ngxs/store';
import { SessionState } from '@platform-frontend/account';
import { Observable } from 'rxjs';

@Component({
  selector: 'yat-academic-header',
  templateUrl: './academic-header.component.html',
  styleUrls: ['./academic-header.component.scss']
})
export class AcademicHeaderComponent {
  @Select(SessionState.email)
  email$: Observable<string | null>;
}
